import React, { useEffect, useRef } from "react";
import styled from "styled-components/macro";
import { useGetCalendlyApi } from "./hooks";
import { isCalendlyEvent } from "./utils";

const Root = styled.div`
  height: 700px;
  width: 100%;
`;

export type TCalendlyScheduledEvent = {
  eventId: string;
  event: {
    uri: string;
  };
  invitee: {
    uri: string;
  };
};

export const CalendlyCalendar: React.FC<{
  meetingUrl: string;
  userName?: string | null;
  userEmail?: string | null;
  onEventScheduled?: (data: TCalendlyScheduledEvent) => void;
  onInitialized?: () => void;
  onDateAndTimeSelected?: () => void;
}> = ({
  meetingUrl,
  userName,
  userEmail,
  onEventScheduled,
  onInitialized,
  onDateAndTimeSelected
}) => {
  const calendlyApi = useGetCalendlyApi();
  const rootRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const messageHandler = function (e: MessageEvent<any>) {
      if (isCalendlyEvent(e)) {
        if (e.data.event === "calendly.event_scheduled") {
          onEventScheduled?.({
            ...e.data.payload,
            eventId: e.data.payload.event.uri.split("/").slice(-1)[0]
          });
        }
        if (e.data.event === "calendly.event_type_viewed") {
          onInitialized?.();
        }
        if (e.data.event === "calendly.date_and_time_selected") {
          onDateAndTimeSelected?.();
        }
      }
    };
    window.addEventListener("message", messageHandler);

    return () => {
      window.removeEventListener("message", messageHandler);
    };
  }, [onEventScheduled, onInitialized, onDateAndTimeSelected]);

  useEffect(() => {
    if (calendlyApi && rootRef.current) {
      rootRef.current.innerHTML = "";
      calendlyApi.initInlineWidget({
        url: meetingUrl,
        parentElement: rootRef.current,
        prefill: {
          name: userName ?? "",
          email: userEmail ?? ""
        }
      });
    }
  }, [calendlyApi, meetingUrl, userEmail, userName]);

  return <Root ref={rootRef}></Root>;
};
